import axios from 'src/utils/axios';
import { basePath } from 'src/api/dataVault/survey';

type DVOpts = { actingOnMemberId?: number | null };

export interface DocFile {
  id: number;
  name: string;
  pdf_file_url: string;
  status: number;
  is_rejected?: boolean;
  created_at: string | null;
}

export interface DocQuestion {
  qit_id: number;
  question_label: string;
  files_required: number;
  files: DocFile[];
}

export interface DocCard {
  group_id: number;
  group_name: string;
  is_multi: boolean;
  answer_group_id: number | null;
  instance_label: string | null;
  questions: DocQuestion[];
}

export interface FileQuestionsResponse {
  cards: DocCard[];
}

export const getSurveyFileQuestions = (
  surveyId: number,
  opts: DVOpts = {}
): Promise<FileQuestionsResponse> =>
  axios
    .get<FileQuestionsResponse>(`${basePath(surveyId, opts)}/file-questions/`)
    .then((r) => r.data);
